// src/components/Login.js - Enhanced with Verification Success Banner
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showResetForm, setShowResetForm] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [verificationMessage, setVerificationMessage] = useState('');

  const { login, resetPassword, error, setError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get redirect path from location state
  const from = location.state?.from?.pathname || '/dashboard';

  // Check for verification success message
  useEffect(() => {
    if (location.state?.verified && location.state?.message) {
      setVerificationMessage(location.state.message);
      setEmail(location.state.email || '');
    }
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    const result = await login(email, password);
    
    if (result.success) {
      console.log('✅ Login success, redirecting to:', from);
      navigate(from, { replace: true });
    }
    // Error handling is done in AuthContext
    setIsLoading(false);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    const result = await resetPassword(resetEmail);
    
    if (result.success) {
      setResetMessage('Wachtwoord reset link is verstuurd naar je email.');
      setShowResetForm(false);
      setResetEmail('');
    } else {
      setResetMessage('Er is een fout opgetreden: ' + result.error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Inloggen</h1>
          <p>Log in om je RelatieScan te beheren</p>
        </div>

        <div className="login-content">
          {/* Verification Success Banner */}
          {verificationMessage && (
            <div className="verification-success-banner">
              <div className="banner-icon">✅</div>
              <div className="banner-content">
                <h3>Email Geverifieerd!</h3>
                <p>{verificationMessage}</p>
              </div>
            </div>
          )}

          {/* Error Message */}
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {/* Reset Message */}
          {resetMessage && (
            <div className="success-message">
              {resetMessage}
            </div>
          )}

          {!showResetForm ? (
            /* Login Form */
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">
                  Email adres
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="form-input"
                  placeholder="naam@bedrijf.nl"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  Wachtwoord
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="form-input"
                  placeholder="Je wachtwoord"
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="btn-primary"
              >
                {isLoading ? (
                  <span className="loading-content">
                    <div className="loading-spinner"></div>
                    Inloggen...
                  </span>
                ) : (
                  'Inloggen'
                )}
              </button>

              <div className="form-footer">
                <button
                  type="button"
                  onClick={() => setShowResetForm(true)}
                  className="link-button"
                >
                  Wachtwoord vergeten?
                </button>
              </div>

              
<div className="auth-divider">
  <span>Nog geen account?</span>
</div>

<div className="auth-links">
  <Link to="/register" className="btn-secondary">
    Account Aanmaken
  </Link>
</div>

            </form>
          ) : (
            /* Password Reset Form */
            <form onSubmit={handleResetPassword}>
              <div className="form-group">
                <label className="form-label">
                  Email adres voor wachtwoord reset
                </label>
                <input
                  type="email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  required
                  className="form-input"
                  placeholder="naam@bedrijf.nl"
                />
              </div>

              <button type="submit" className="btn-primary">
                Reset Link Versturen
              </button>

              <button
                type="button"
                onClick={() => setShowResetForm(false)}
                className="btn-secondary"
              >
                Terug naar inloggen
              </button>
            </form>
          )}
        </div>

        <div className="login-footer">
          <Link to="/" className="footer-link">
            ← Terug naar homepage
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;